// src/pages/Admin/Notifications/view/CreateNotification.tsx

import React from "react";
import { Grid } from "@material-ui/core";

import BreadcrumbAndTitle from "@components/BreadcrumbAndTitle";
import { BreadcrumbChild } from "@components/BreadcrumbCustom";

import ROUTES from "@config/routes";

import NotificationFormikContainer from "../resource/form/NotificationFormikContainer";
import { NotificationFormModeEnum } from "../resource/form/hook/interface";

const breadcrumbData: BreadcrumbChild[] = [
  { label: "Início", link: ROUTES.ADMIN_ROUTES.HOME },
  { label: "Notificações", link: ROUTES.ADMIN_ROUTES.NOTIFICATIONS.ROOT },
  { label: "Criar" },
];

const CreateNotification: React.FC = () => {
  return (
    <Grid container>
      <Grid item xs={12}>
        <BreadcrumbAndTitle
          breadcrumbData={breadcrumbData}
          title="Criar notificação"
        />
      </Grid>

      <Grid item xs={12}>
        <NotificationFormikContainer mode={NotificationFormModeEnum.CREATE} />
      </Grid>
    </Grid>
  );
};

export default CreateNotification;
